import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles';
import { ListItem, ListItemIcon, ListItemText, Divider, List, ListSubheader,Snackbar } from '@material-ui/core';
import { green } from '@material-ui/core/colors';
import AppsIcon from '@material-ui/icons/Apps';
import CheckCircleSharpIcon from '@material-ui/icons/CheckCircleSharp';
import CircularProgress from '@material-ui/core/CircularProgress';
import MuiAlert from '@material-ui/lab/Alert';
import axios from '../../Helpers/Axiosbase'
import * as actions from '../../Store/Actions'

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}


const useStyles = makeStyles(theme => ({  
  header: {
    background: 'linear-gradient(45deg,#3f51b5 90%,#3f51b5 10%)',
    color: 'white',
    fontSize: 18
  },
  loader: {
    position: 'absolute',
    left: '40%',
    top: '250px',
  },
  listitem: {
    paddingTop: '3px',
    paddingBottom: '3px',
    paddingLeft: '8px',
    // border: '1px solid rgba(0,0,0,.125)',
    // backgroundColor:'#f8f9fa!important',
  
  },
  listitemicon: {
    minWidth: '35px'
  },
  listItemText: {
    fontSize: '15px',
    fontFamily: 'Open Sans, sans-serif',
  },
  svgIcon: {
    fontSize: '1.3rem',
  },

}));

export default function AppSelector() {

  const classes = useStyles();
  const [state, setState] = React.useState({
    showLoader: true,
    allApps: [],
    allComponents: []
  });
  const [selectedIndex, setSelectedIndex] = React.useState(0);

  

  const reduxAuth = useSelector((state) => state.auth)
  const appcomponent = useSelector((state) => state.appcomponent)
  const dispatch = useDispatch();

  const urladd = window.location.href;

  const [errorMessage,setErrorMessage]=React.useState({
    open:false,
    errmsg:null,
  });

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    // setOpenAlert({
    //   open: false,
    //   btn: ''
    // });
  };


  const handleListItemClick = (data, index) => {
    setSelectedIndex(index);
    dispatch(actions.selectedApp(data))
  };

  if (appcomponent.selectedApp === null) {
    dispatch(actions.selectedApp(state.allApps[0]));
    setSelectedIndex(0);
  }

  var getAppsAndComponents = () => {
   
    let url = "getAll"
    let postdata = { objectName: "app", token: reduxAuth.token, userId: reduxAuth.userId }
    axios.post(url, postdata)
      .then(appsResponse => {
        let allapps=appsResponse.data.response.map((data,index)=>{
          data.displaySequence=index+1
          return data
        })
        let postdata = { objectName: "component", token: reduxAuth.token, userId: reduxAuth.userId }
        axios.post(url, postdata)
          .then(componentResponse => {
            if(appcomponent.allComponent==null || appcomponent.allComponent==undefined )
            {
              dispatch(actions.allComponent(componentResponse.data.response));
            }
          
            if(appcomponent.selectedApp === null || appcomponent.selectedApp===undefined){
            dispatch(actions.selectedApp(appsResponse.data.response[0]));
            setSelectedIndex(0);
            }
            else{
              setSelectedIndex(appcomponent.selectedApp.displaySequence-1)
            }
           
            setState({ showLoader: false, allApps: allapps });
          })
          .catch(
            err => {
              if(typeof err.response!="object")
              {
                setErrorMessage({
                  open:true,
                  // errmsg:err
                })
                console.log(err);
              }
              else 
              {
                if(err.response.status === 403) {
                  // console.log(err.response.data.responseMessage);
                  setErrorMessage({
                    open:true,
                    errmsg:err.response.data.responseMessage
                  })
                  dispatch(actions.authSuccess(reduxAuth.userId, reduxAuth.token, reduxAuth.isAdmin, reduxAuth.environments, false));
              }
            }
          }
          )
      })
      .catch(err => {
          if(typeof err.response!="object")
              {
                setErrorMessage({
                  open:true,
                  // errmsg:err
                })
                console.log(err);
              }
              else 
              {
                if(err.response.status === 403) {
                  console.log(err.response.data.responseMessage);
                  setErrorMessage({
                    open:true,
                    errmsg:err.response.data.responseMessage
                  })
                   setState({ allApps: [] });
                  dispatch(actions.authSuccess(reduxAuth.userId, reduxAuth.token, reduxAuth.isAdmin, reduxAuth.environments, false));
              }
            }
      });

  }

  useEffect(() => {
   
      getAppsAndComponents();
   
  }, []);

  return (
  <div>    
    <Snackbar
          open={errorMessage.open} autoHideDuration={3000} anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
          onClose={handleClose}>
            <Alert 
              severity="error"
              color="error"
              variant="filled">
              {errorMessage.errmsg!=null?errorMessage.errmsg:" NetWork Error:Please Check Your Internet Connection"}
            </Alert>
    </Snackbar>
 
    <List
      component="nav"
      aria-labelledby="nested-list-subheader"
      subheader={
        <ListSubheader className={classes.header} component="div" id="nested-list-subheader">
          Apps
        </ListSubheader>
      }>
      <Divider></Divider>
      <Divider></Divider>
      <Divider></Divider>
      {state.showLoader ? <CircularProgress className={classes.loader} /> : null}
      {state.allApps.map((data, index) => {
        return (
          <ListItem button key={index} onClick={() => handleListItemClick(data, index)} selected={selectedIndex === index} disabled={urladd.includes("ManageConfig") || urladd.includes("AddConfiguration") || (appcomponent.selectedEnvironment != null && appcomponent.selectedEnvironment.isSync.toString() === "0")} className={classes.listitem}>
            <ListItemIcon className={classes.listitemicon}>
              {selectedIndex === index ? <CheckCircleSharpIcon style={{ color: green[900], fontSize: '1.3rem' }}></CheckCircleSharpIcon> : <AppsIcon style={{ color: 'black', fontSize: '1.3rem' }}></AppsIcon>}
            </ListItemIcon>
            <ListItemText primary={data.displayName} classes={{ primary: classes.listItemText }}></ListItemText>
          </ListItem>
        )
      })}
      <Divider></Divider>
    </List>
    </div>
  );
}
